import { render, staticRenderFns } from "./Breadcrums.vue?vue&type=template&id=5e17ea3a&scoped=true&"
import script from "./Breadcrums.vue?vue&type=script&lang=js&"
export * from "./Breadcrums.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrums.vue?vue&type=style&index=0&id=5e17ea3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e17ea3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem})
